import {
    SET_HISTORY_LIST,
    SET_USER_HISTORY_COUNT
} from '../../actions';

const initialState = {
    historyList: [],
    historyCount: 0
}

function historyListReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_HISTORY_LIST:
            newState.historyList = action.historyList;
            newState.historyCount = state.historyCount;
            return newState;

        case SET_USER_HISTORY_COUNT:
            newState.historyList = state.historyList;
            newState.historyCount = action.historyCount;
            return newState;

        default:
            return state;
    }
}

export default historyListReducer;
